import { hexagonPath } from ':cloud/widgets/buildQuest/assets/hexagon';
import { starPath, starStyles } from ':cloud/widgets/buildQuest/assets/star';
import { SVG_PROPS, TILE_HEIGHT, TILE_WIDTH } from ':cloud/widgets/buildQuest/constants';

type TileOutlinedProps = {
  className?: string;
};
export function TileOutlined({ className }: TileOutlinedProps): React.ReactElement {
  return (
    <svg {...SVG_PROPS}>
      <defs>
        <mask id="strokeMask">
          <path d={hexagonPath} strokeWidth="3" stroke="#FFF" />
          {/* Star in the center */}
          <path d={starPath} fill="#fff" className={starStyles} />
        </mask>
      </defs>

      <foreignObject width={TILE_WIDTH} height={TILE_HEIGHT} mask="url(#strokeMask)">
        <div className={className} style={{ height: `${TILE_HEIGHT}px` }} />
      </foreignObject>
    </svg>
  );
}
